import { Box } from "@mui/material";

import DevicesMakesTable from "./components/DevicesMakesTable";

const DevicesMakes = (): JSX.Element => {
  return (
    <Box>
      <DevicesMakesTable />
    </Box>
  );
};

export default DevicesMakes;
